import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import Button from '../../components/Button';
import Header from '../../components/Header';
import Image from '../../components/Image';
import LockSmallImg from './lock-small.svg';
import RepVisitsUpgradeForm from '../RepVisitsUpgradeForm';
import upgradeYourScheduleMessages from './your-schedule-messages';

import './styles.css';

const genericMessages = defineMessages({
  premiumFeature: {
    id: 'unlock.premiumFeature',
    defaultMessage: 'Premium Feature',
  },
});

class RepVisitsUnlockPremiumSidebar extends React.PureComponent {
  state = {
    openModal: false,
  };

  closeModal = () => {
    this.setState({ openModal: false });
  };

  showModal = () => {
    this.setState({ openModal: true });
  };

  render() {
    const { openModal } = this.state;
    return (
      <div id="unlock-container" styleName="container">
        <div styleName="header-container">
          <Header as="h2">
            <FormattedMessage {...upgradeYourScheduleMessages.featureName} />
            <span styleName="heading-text-pink">
              <FormattedMessage {...genericMessages.premiumFeature} />
            </span>
            <Image src={LockSmallImg} centered alt="locked" />
          </Header>
        </div>
        <div styleName="yourschedule">
          <div styleName="unlock-text-area">
            <div styleName="sub-heading-details"><FormattedMessage {...upgradeYourScheduleMessages.featureSummary} /></div>
            <Button styleName="button-upgrade" onClick={this.showModal}>
              <span>
                <FormattedMessage {...upgradeYourScheduleMessages.featureUnlockAction} />
              </span>
            </Button>
          </div>
        </div>
        <RepVisitsUpgradeForm open={openModal} onClose={this.closeModal} />
      </div>
    );
  }
}

export default RepVisitsUnlockPremiumSidebar;
